import { Icon, InputUI } from '@fourthwall/components';
import { ArrowShortDownIcon, CloseIcon } from '@fourthwall/icons';
import React, { memo, useCallback } from 'react';
export const CategoryActionIcon = memo(({ isInputActive, hasValue, disabled, onReset, onSelect }) => {
    const iconType = isInputActive && hasValue ? 'reset' : 'select';
    const icon = iconType === 'reset' ? CloseIcon : ArrowShortDownIcon;
    const handleClick = useCallback(() => {
        if (disabled)
            return;
        if (iconType === 'reset') {
            onReset();
            return;
        }
        onSelect();
    }, [isInputActive, iconType, onReset, onSelect]);
    return (React.createElement(InputUI.ActionIconContainer, { "$size": "large", "$hoverable": !disabled, "data-testid": "Input.ActionIcon", onClick: handleClick },
        React.createElement(Icon, { component: icon, height: 15 })));
});
